export default [
    {name: 'Caracole -1', id: 1},
    {name: 'Bernhardt -2', id: 2},
    {name: 'Eichholtz', id: 3},
    {name: 'Theodore Alexander', id: 4},
    {name: 'Eclipse', id: 5},
    {name: 'Ambiance', id: 6},
    {name: 'Maya Paris -7', id: 7},
    {name: "That's Living", id: 16}
]